import { DateRange } from 'react-day-picker';
import api from './baseApi';

export const addCollector = async (collector: Collector) => {
  try {
    const response = await api.post('/collector/orders', collector);
    return response;
  } catch (error: any) {
    throw new Error(error.response.data.message);
  }
};

export const getCollectors = async ({
  page = 1,
  perPage = 10,
  searchTerm,
  selectedWilaya,
  status,
  selectedCollector,
  dateRange,
}: {
  page?: number;
  perPage?: number;
  searchTerm?: string;
  selectedWilaya?: string;
  status?: string;
  selectedCollector?: string;
  dateRange?: DateRange | undefined;
}) => {
  try {
    let query = `?page=${page}&perPage=${perPage}`;
    if (searchTerm) {
      query += `&fullname=${searchTerm}`;
    }

    if (selectedWilaya) {
      query += `&wilaya=${selectedWilaya}`;
    }

    if (status) {
      query += `&status=${status}`;
    }

    if (dateRange?.from) {
      query += `&startDate=${dateRange.from.toISOString()}`;
    }

    if (dateRange?.to) {
      // Add one day to the end date
      const endDate = new Date(dateRange.to);
      endDate.setDate(endDate.getDate() + 1);
      query += `&endDate=${endDate.toISOString()}`;
    }

    if (selectedCollector) {
      query += `&collectorId=${selectedCollector}`;
    }
    const response = await api.get(`/collector/orders${query}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching collectors', error);
    return [];
  }
};

export const deleteCollector = async (collectorId: string) => {
  try {
    const response = await api.delete(`/collector/orders/${collectorId}`);
    return response;
  } catch (error) {
    console.error('Error deleting collector', error);
  }
};
